module.exports = __webpack_public_path__ + "static/media/lab_profile_grid.80f322c5.svg";